import ConnectorSkeleton from '@/modules/charge-center/skeleton-components/connector-skeleton';

const GridChargePointsSkeleton = () => {
  return (
    <div className="$tw-grid $tw-grid-cols-2 $tw-gap-3 $tw-rounded-md $tw-border $tw-border-foreground/20 $tw-bg-background $tw-p-4 md:$tw-grid-cols-3 lg:$tw-grid-cols-3">
      {/* Connectors area */}
      {Array.from({ length: 6 }).map((_, i) => (
        <ConnectorSkeleton key={`connector-skeleton-${i}`} />
      ))}
    </div>
  );
};

export default GridChargePointsSkeleton;
